import React from "react";
import "./first.css";
class FirstPage extends React.Component {
  render() {
    return (
      <div className="first_page">
        <section className="header">
          <h1>Dixit Kumar</h1>
          <p>
            Compititive Programmer || Problem Solver || Engineer of things.
            <br/>
            Creator of{" "}
            
            <a href="https://play.google.com/store/apps/details?id=com.javacodes.dixit.mdmbihar&hl=en_IN">
              MDM BIHAR
            </a>
          </p>
        </section>
        <div className="icons">
          <a href="https://github.com/errorr404" className="icons-item">
            <i className="fab fa-github" />
          </a>
          <a
            href="https://in.linkedin.com/in/dixit-kumar-1b724611a"
            className="icons-item"
          >
            <i className="fab fa-linkedin-in" />
          </a>
          <a
            href="https://www.stopstalk.com/user/profile/error404_"
            className="icons-item"
          >
            <i className="fas fa-code" />
          </a>
        </div>
      </div>
    );
  }
}
export default FirstPage;
